export async function waitForRenderableContainerAsync(container: HTMLElement, timeoutMs: number = 5000): Promise<void> {
    const startTime = Date.now();

    while (!isRenderableElement(container)) {
        if (Date.now() - startTime >= timeoutMs)
            throw new Error("Map container was not renderable within the timeout.");

        await waitForNextFrameAsync();
    }
}

export function waitForNextFrameAsync(): Promise<void> {
    return new Promise(resolve => requestAnimationFrame(() => resolve()));
}

function isRenderableElement(element: HTMLElement): boolean {
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
}
